document.addEventListener('DOMContentLoaded', function () {

  const openBtn = document.getElementById('expertHelpBtn');
  const modal = document.getElementById('expertHelpModal');
  const closeBtn = document.getElementById('expertHelpClose');
  const slides = document.querySelectorAll('.expert-help-slide');

  /* Popup */

  if (openBtn && modal) {

    openBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      modal.classList.toggle('active');
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        modal.classList.remove('active');
      });
    }

    document.addEventListener('click', function (e) {
      if (
        !modal.contains(e.target) &&
        !openBtn.contains(e.target)
      ) {
        modal.classList.remove('active');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        modal.classList.remove('active');
      }
    });
  }

  /* Image Rotation */

  if (slides.length > 1) {

    let currentSlide = 0;

    setInterval(function () {

      slides[currentSlide].classList.remove('active');

      currentSlide = (currentSlide + 1) % slides.length;

      slides[currentSlide].classList.add('active');

    }, 3000);

  }

});